import { inject, Injectable } from '@angular/core';
import { API_URLS, WebServiceProvider } from '@pinnakl/core/web-services';
import { Aum } from '@pinnakl/poems/aum/domain';

@Injectable({ providedIn: 'root' })
export class AumApiService {
  private readonly wsp = inject(WebServiceProvider);
  private readonly apiUrls = inject(API_URLS);

  getAums(): Promise<Aum[]> {
    return this.wsp.get<Aum[]>({ endpoint: this.apiUrls.omsNavsSod });
  }
}
